// ============================================
// FAMILY MOON - customizer UI (Alpine)
// ============================================
//
// The sidebar bindings for the family moon customizer, against the state in
// hor-moon-myjs.js (window.HMoonCore / Alpine.store('hmoon')). Section markup
// carries `@click="pickX($el)"` and `:class` bindings; everything here reads
// the store, never the tiles' classes (Alpine updates the DOM a microtask
// after a store write).
//
// Loads after hor-moon-myjs.js and before alpine.min.js (document order =
// execution order for deferred scripts), so the component is registered
// before Alpine starts.

(function () {
'use strict';

var C = window.HMoonCore;
if (!C) { console.error('[hor-moon-ui] hor-moon-myjs.js did not load'); return; }

function S() { return C.store(); }

var GIFT_BY_SLUG = {
    no_gift__picker: 'none',
    ribbon_wrap__picker: 'ribbon',
    gift_wrap__picker: 'giftwrap',
    bundle__picker: 'bundle'
};

// The product type a size / frame tile belongs to, from its picker's
// data-state ("{{ option1 | handleize }}__picker").
function tileType(el) {
    var w = el.closest('.h-state__picker');
    var state = w ? w.getAttribute('data-state') : '';
    return C.productTypes().find(function (t) { return C.stateKey(t) === state; }) || null;
}

var actions = {
    pickType: function (el) { C.selectType(el.getAttribute('data-option')); },
    pickSize: function (el) { C.selectSize(el.getAttribute('data-option')); },
    pickFrame: function (el) { C.selectFrame(el.getAttribute('data-option')); },
    pickGift: function (el) { C.setGift(GIFT_BY_SLUG[el.getAttribute('data-dropdown')] || 'none'); },

    typeActive: function (el) { return S().type === el.getAttribute('data-option'); },
    // Each type's size / frame grid keeps its own selection while hidden.
    sizeActive: function (el) {
        return (S().sel[tileType(el)] || {}).size === el.getAttribute('data-option');
    },
    frameActive: function (el) {
        var type = tileType(el);
        return C.hasFrameChoice(type) && (S().sel[type] || {}).frame === el.getAttribute('data-option');
    },
    // Availability is for the type's current frame colour.
    sizeOk: function (el) {
        S().sel; // track selection changes
        return C.sizeAvailable(tileType(el), el.getAttribute('data-option'));
    },
    sizePrice: function (p) {
        var el = p.closest('[data-option]');
        var type = tileType(el);
        var size = el.getAttribute('data-option');
        var frame = C.hasFrameChoice(type) ? (S().sel[type] || {}).frame : null;
        if (C.isUkOnlySize(type, size)) return 'UK delivery only';
        var v = C.sizeVariant(type, size, frame);
        return v ? ((window.hVariantMoney || {})[v.id] || '') : 'Sold Out';
    },
    // Only the chosen type's frame / size pickers show (frames only for a
    // type with a frame choice). The Liquid loop also renders an empty-type
    // wrapper, which never matches.
    stateVisible: function (el) {
        var type = S().type;
        if (!type || el.getAttribute('data-state') !== C.stateKey(type)) return false;
        if (el.classList.contains('h-state_3')) return C.hasFrameChoice(type);
        return true;
    },
    giftActive: function (el) {
        return S().gift.selectedOption === GIFT_BY_SLUG[el.getAttribute('data-dropdown')];
    },
    isPrintType: function () { S().type; return C.isPrintType(); },

    // ---- design ----
    pickComposition: function (el) { C.setComposition(el.getAttribute('data-composition')); },
    pickTemplate: function (el) { C.setTemplate(el.getAttribute('data-template')); },
    pickBackground: function (el) { C.setBackground(el.getAttribute('data-bg')); },
    pickTexture: function (el) { C.setTexture(texMoonId(el), el.getAttribute('data-texture')); },
    compActive: function (el) { return S().composition === el.getAttribute('data-composition'); },
    templateActive: function (el) { return String(S().template) === el.getAttribute('data-template'); },
    bgActive: function (el) { return S().background === el.getAttribute('data-bg'); },
    texActive: function (el) { return S().textures[texMoonId(el)] === el.getAttribute('data-texture'); },

    // ---- fonts ----
    // The highlighted tile is the current scope's font; on "Both" only when
    // message and details agree.
    fontActive: function (font) {
        var s = S();
        var target;
        if (s.fontScope === 'details') target = s.detailsFont;
        else if (s.fontScope === 'message') target = s.messageFont;
        else target = (s.messageFont === s.detailsFont) ? s.messageFont : null;
        return target !== null && target === font;
    },
    onFontClick: function (e) {
        var scopeBtn = e.target.closest('.sm2-font-scope-btn[data-scope]');
        if (scopeBtn) { C.setFontScope(scopeBtn.getAttribute('data-scope')); return; }
        var btn = e.target.closest('.sm2-font-btn[data-font]');
        if (btn) C.chooseFont(btn.getAttribute('data-font'));
    }
};

// Each moon's hue swatches carry data-moon-id (their picker data-moon-tex).
function texMoonId(el) {
    var picker = el.closest('.h-moon-texture-picker');
    return parseInt(el.getAttribute('data-moon-id'), 10) || parseInt(picker && picker.getAttribute('data-moon-tex'), 10) || null;
}

function qa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

// ============================================
// STEPS AND FOOTER
// ============================================
// The step nav, panels and footer buttons come from shared snippets, so they
// are painted from the store here rather than bound in the markup. Classes
// only, never inline display: the mobile CSS drives the buttons off
// .h-show-submit / .h-on-final-step with !important.
function paintSteps() {
    var step = S().step;
    var tabs = qa('.cust-step-nav .cust-step-tab');
    tabs.forEach(function (t, i) { t.classList.toggle('active', i === step); });
    qa('.h-element__settings').forEach(function (st, i) {
        st.classList.toggle('h-active__settings', i === step);
        if (i === step) st.classList.add('h-visited');
    });
    var last = step === tabs.length - 1;
    qa('.h-submit__form').forEach(function (b) { b.classList.toggle('h-show-submit', last); });
    qa('.h-add__to--cart').forEach(function (c) { c.classList.toggle('h-on-final-step', last); });
}
function paintButtonLabel() {
    var s = S();
    s.template; s.editMode; s.locations.moon1; s.locations.moon2; s.locations.moon3; s.locations.moon4;
    s.dates.moon1; s.dates.moon2; s.dates.moon3; s.dates.moon4;
    window.updateHAddToCartButtonText();
}

document.addEventListener('alpine:init', function () {
    window.Alpine.data('hmoonUi', function () { return Object.assign({}, actions); });
    window.Alpine.effect(paintSteps);
    window.Alpine.effect(paintButtonLabel);
});

// ============================================
// HOOKS FROM THE CORE
// ============================================
// A variant change can move the frame border (Print has none, Framed and
// Canvas a 22px border that animates over 0.3s) and the print's aspect
// ratio: re-measure the gift overlays mid-way and after the transition.
var lastType = null;
window.onHMoonVariantChange = function () {
    var c = C.currentSelection();
    if (typeof window.updateHMoonPrintAspect === 'function') window.updateHMoonPrintAspect(c.size || '');
    if (c.type !== lastType) {
        lastType = c.type;
        if (typeof window.hMoonOn3DTypeChange === 'function') window.hMoonOn3DTypeChange();
    }
    [100, 400].forEach(function (ms) {
        setTimeout(function () {
            if (typeof window.renderHOverlays === 'function') window.renderHOverlays();
        }, ms);
    });
};

// The 2D overlays and both 3D mockups follow the wrapping (bundle = paper
// + ribbon + bow). Print's quiet downgrade only re-renders the overlays.
window.onHMoonGiftChange = function (option, opts) {
    if (typeof window.renderHOverlays === 'function') window.renderHOverlays();
    if (opts && opts.degrade) return;
    var canvas = window.HMoon3DMockup;
    if (canvas && typeof canvas.showRibbon === 'function') {
        if (window.hRibbonSelected) canvas.showRibbon(); else canvas.hideRibbon();
    }
    var framed = window.HMoonFramedMockup;
    if (framed && typeof framed.showRibbon === 'function') {
        if (window.hRibbonSelected) framed.showRibbon(); else framed.hideRibbon();
    }
    if (framed && typeof framed.showGiftWrap === 'function') {
        if (window.hGiftWrapSelected) {
            framed.showGiftWrap();
            if (typeof framed.setWrapDesign === 'function') framed.setWrapDesign(window.hmGiftPaper || 'dots');
        } else {
            framed.hideGiftWrap();
        }
    }
};

// ============================================
// INITIAL SELECTION + ?variant= DEEP LINK
// ============================================
// First product type (Framed) on its first buyable size and first colour.
// Google Merchant Center links carry ?variant=<advertised offer id>: select
// it so the advertised variant's price is what renders (MC's automated-
// discounts review checks it). A reopened design is applied later by the
// hydrator through HMoonCore.restoreSelection.
function variantFromUrl() {
    try {
        var vid = new URLSearchParams(window.location.search).get('variant');
        if (!vid) return null;
        return (window.hProductVariants || []).find(function (v) { return String(v.id) === String(vid); }) || null;
    } catch (e) { return null; }
}
function setInitialSelection() {
    C.selectType(C.productTypes()[0]);
    var uv = variantFromUrl();
    if (uv) {
        C.restoreSelection(uv.option1, uv.option2, uv.option3);
        console.log('🔗 H-Moon URL variant preselected:', uv.option1, '/', uv.option2, '/', uv.option3 || '—');
    }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setInitialSelection);
else setInitialSelection();

})();
